import React, { Component } from 'react'
import './Nav.css'
import { NavLink } from 'react-router-dom'

class Nav extends Component {
  render () {
    return (
      <div className='nav'>
        <div className='nav__container'>
          <div className='nav__title'>Tu cuenta</div>
          <NavLink to='/account' className={({ isActive }) => isActive ? 'nav__option nav__option--active' : 'nav__option'}>Configuración de cuenta</NavLink>
          <div className='nav__title'>Ayuda</div>
          <NavLink to='/rules' className={({ isActive }) => isActive ? 'nav__option nav__option--active' : 'nav__option'}>Reglas</NavLink>
          <NavLink to='/faq' className={({ isActive }) => isActive ? 'nav__option nav__option--active' : 'nav__option'}>Preguntas frecuentes</NavLink>
          <div className='nav__title'>Nosotros</div>
          <NavLink to='/about' className={({ isActive }) => isActive ? 'nav__option nav__option--active' : 'nav__option'}>Acerca de</NavLink>
          <NavLink to='/contact' className={({ isActive }) => isActive ? 'nav__option nav__option--active' : 'nav__option'}>Contáctanos</NavLink>
          <p className='nav__copy'>&copy; {new Date().getFullYear()} STADIUM<br />V 0.4.0</p>
        </div>
      </div>
    )
  }
}

export default Nav
